module.exports = __webpack_public_path__ + "static/lobster_sandwich-769f718c3ea4fe74a3df3a516f6fbe47.png";